import { cn } from "@productlane/lib/src/cn"

import { MetaInfo } from "@/components/meta-info"
import { api } from "@/lib/api"
import { hasLinearConnection } from "@/lib/linear-connection"
import { useZeroWorkspace } from "@/lib/zero"
import { LinearCustomersDisabledWarning } from "../customers-disabled-warning"
import { PlanPill } from "../plan-pill"
import { SettingsHeader } from "../settings-header"
import { SupportPortalSettingsContent } from "../support-portal-settings-content"

export function SupportPortalSettingsPage() {
	const workspace = useZeroWorkspace()

	// Refetches on focus: the warning sends people to Linear in another tab.
	const isCustomersEnabled = api.linear.customersEnabled.useQuery()
	const customersDisabled =
		isCustomersEnabled.data === false && hasLinearConnection(workspace)

	return (
		<>
			<MetaInfo title="Support Portal" />

			<SettingsHeader
				title="Support Portal"
				titleSuffix={<PlanPill plan="scale" />}
				subtitle="Let customers view and respond to their messages and Linear requests."
				docsArticle="7e861235-26a4-4b00-9268-a0e82258bbe6"
			/>

			{customersDisabled && <LinearCustomersDisabledWarning />}

			<SupportPortalSettingsContent
				className={cn({ "opacity-40": customersDisabled })}
			/>
		</>
	)
}
